if($('body .date-range-filter').length > 0) {
    $('body .date-range-filter').daterangepicker();
    $('body').on('change', '.date-range-filter', function() {
        $($(this).attr('data-form')).submit();
    });
}
